import React from "react";
import { useNavigate } from "react-router-dom";
import "./AppCardActividad.css";

export default function AppCardActividad({ img, desc, descripcion, onClick, actividadId }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (actividadId) {
      navigate(`/actividades/${actividadId}`);
    } else if (onClick) {
      onClick();
    }
  };

  const plainDesc = descripcion
    ? descripcion.replace(/<[^>]+>/g, "").trim()
    : "";

  return (
    <div className="activ-card">
      <img src={img} alt={desc} className="activ-img" />
      <div className="activ-body">
        {desc && <p className="activ-desc">{desc}</p>}
        {plainDesc && <p className="activ-subdesc">{plainDesc}</p>}
        <button className="activ-btn" onClick={handleClick}>
          Descargar
        </button>
      </div>
    </div>
  );
}
